import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";

import MarketingLayout from "@/pages/marketing/MarketingLayout";
import Home from "@/pages/marketing/Home";
import Product from "@/pages/marketing/Product";
import Architecture from "@/pages/marketing/Architecture";
import Security from "@/pages/marketing/Security";
import Pricing from "@/pages/marketing/Pricing";
import MSP from "@/pages/marketing/MSP";
import Developers from "@/pages/marketing/Developers";
import Docs from "@/pages/marketing/Docs";

import Login from "@/pages/auth/Login";

import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/DashboardHome";
import DomainsList from "@/pages/dashboard/DomainsList";
import AddDomainWizard from "@/pages/dashboard/AddDomainWizard";
import DomainDetail from "@/pages/dashboard/DomainDetail";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="label-mono">Verifying session…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/architecture" element={<Architecture />} />
        <Route path="/security" element={<Security />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/msp" element={<MSP />} />
        <Route path="/developers" element={<Developers />} />
        <Route path="/docs" element={<Docs />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardHome />} />
        <Route path="domains" element={<DomainsList />} />
        <Route path="domains/new" element={<AddDomainWizard />} />
        <Route path="domains/:id" element={<DomainDetail />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
